// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RITN","badges":"styles_badges__1ga0Q"};